/**
 * Web Platform Detection
 */

import type { DeviceType, Platform, PlatformInfo } from "./types";

export const getPlatform = (): Platform => "web";

export const getDeviceType = (): DeviceType => "browser";

export const isWeb = true;
export const isNative = false;
export const isIOS = false;
export const isAndroid = false;

export const getPlatformInfo = (): PlatformInfo => ({
  platform: "web",
  isWeb: true,
  isNative: false,
  isIOS: false,
  isAndroid: false,
});
